export enum CountryEnum {
  AT = 'at',
  BG = 'bg',
  CH = 'ch',
  CZ = 'cz',
  DE = 'de',
  ES = 'es',
  FR = 'fr',
  HR = 'hr',
  HU = 'hu',
  IT = 'it',
  LI = 'li',
  LU = 'lu',
  PL = 'pl',
  RO = 'ro',
  SI = 'si',
  SK = 'sk',
  RAIFFEISEN = 'raiffeisen',
  RCM = 'rcm',
}

export type Country = `${CountryEnum}`;

export const isCountry = (value: string): value is CountryEnum => {
  return Object.values(CountryEnum).includes(value as CountryEnum);
};
